import React from 'react';
import { FormattedMessage } from '../../../../util/reactIntl';
import css from './SectionUSP.module.css';

const EasyListingIcon = () => (
  <svg className={css.icon} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
    <rect
      x="4"
      y="2"
      width="16"
      height="20"
      rx="2"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.5"
    />
    <line
      x1="8"
      y1="7"
      x2="16"
      y2="7"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
    <line
      x1="8"
      y1="11"
      x2="16"
      y2="11"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
    <line
      x1="8"
      y1="15"
      x2="12"
      y2="15"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
  </svg>
);

const EarnMoreIcon = () => (
  <svg className={css.icon} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
    <circle cx="12" cy="12" r="9" fill="none" stroke="currentColor" strokeWidth="1.5" />
    <path
      d="M14.5 9.5c-.4-1-1.3-1.5-2.5-1.5-1.5 0-2.5.8-2.5 2s1 1.8 2.5 2.2c1.5.4 2.5 1 2.5 2.3s-1 2-2.5 2c-1.2 0-2.1-.5-2.5-1.5"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
    <line
      x1="12"
      y1="6"
      x2="12"
      y2="7.5"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
    <line
      x1="12"
      y1="16.5"
      x2="12"
      y2="18"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
  </svg>
);

const VerifiedIcon = () => (
  <svg className={css.icon} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M12 3l-8 4v5c0 5.25 3.4 10.15 8 11 4.6-.85 8-5.75 8-11V7l-8-4z"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinejoin="round"
    />
    <path
      d="M9 12l2 2 4-4"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const USP_ITEMS = [
  {
    icon: EasyListingIcon,
    titleId: 'SectionUSP.easyListingTitle',
    textId: 'SectionUSP.easyListingText',
  },
  { icon: EarnMoreIcon, titleId: 'SectionUSP.earnMoreTitle', textId: 'SectionUSP.earnMoreText' },
  { icon: VerifiedIcon, titleId: 'SectionUSP.verifiedTitle', textId: 'SectionUSP.verifiedText' },
];

const SectionUSP = () => (
  <section className={css.root}>
    <div className={css.container}>
      {USP_ITEMS.map(({ icon: Icon, titleId, textId }) => (
        <div key={titleId} className={css.item}>
          <Icon />
          <h3 className={css.title}>
            <FormattedMessage id={titleId} />
          </h3>
          <p className={css.text}>
            <FormattedMessage id={textId} />
          </p>
        </div>
      ))}
    </div>
  </section>
);

export default SectionUSP;
